import { render, staticRenderFns } from "./SingleAddonProduct.vue?vue&type=template&id=211ece79"
import script from "./SingleAddonProduct.vue?vue&type=script&lang=js"
export * from "./SingleAddonProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports